const MessageErreurReseau = 'Une erreur réseau est survenue.';

export default class ErreurReseau extends Error {
  constructor(message = MessageErreurReseau) {
    super(message);

    Object.setPrototypeOf(this, ErreurReseau.prototype);
  }
}
